import cx from 'classnames';

import { useArtists } from 'api/artists';
import useInViewport from 'hooks/useInViewport';

import Avatar from 'shared_components/Avatar';
import Spinner from 'shared_components/Spinner';
import Text from 'shared_components/Text';

import styles from '../../styles.module.scss';

const ArtistAvatar = ({
  avatar,
  twitter,
  insta,
  handle,
}: {
  avatar?: string;
  handle: string;
  insta?: string | null;
  twitter?: string | null;
}) => {
  const twitterURL = 'https://twitter.com/' + twitter;
  const instaURL = 'https://instagram.com/' + insta;
  const Wrapper = window.innerWidth > 900 && (twitter || insta) ? 'a' : 'span';

  return (
    <div className={styles.avatar}>
      <Wrapper
        href={twitter ? twitterURL : insta ? instaURL : undefined}
        className={styles.link}
        target={twitter || insta ? '_blank' : undefined}
        rel={twitter || insta ? 'noreferrer' : undefined}
      >
        <Avatar
          loading="lazy"
          size={60}
          src={avatar}
          isEpicsCdn={false}
          className={styles.artistAvatar}
        />
      </Wrapper>
      <Text weight="semibold" size="sm" className={styles.artistName}>
        {handle || 'You?'}
      </Text>
    </div>
  );
};

const Artists = (props: React.HTMLProps<HTMLDivElement>) => {
  const { data } = useArtists({ seasons: 'Crypto 2021' });
  const { getInView, inView } = useInViewport();

  return (
    <div
      {...props}
      className={cx(styles.artists, props.className)}
      ref={getInView}
    >
      <Text
        as="h3"
        size="3xl"
        weight="medium"
        uppercase
        className={styles.gradientText}
      >
        The <strong>Artists</strong>
      </Text>
      <Text className={styles.paragraph} as="p" size="md" weight="regular">
        The top artists in the NFT universe are contributing some high quality
        art for you to collect!
      </Text>

      <div className={styles.avatarsWrap}>
        <div className={cx(styles.avatars, { [styles.inView]: inView })}>
          {data ? (
            data?.[0].artists.map((a) => {
              const avatar = a.images.find((i) => i.name === 'portrait')?.url;
              return (
                <ArtistAvatar
                  key={a.id}
                  avatar={avatar}
                  handle={a.name}
                  twitter={a.socialTwitter}
                  insta={a.socialTwitter}
                />
              );
            })
          ) : (
            <div className={styles.artistsSpinner}>
              <Spinner centered />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Artists;
